import { Model } from "@vuex-orm/core";
import Call from "./Call";
import ContactInfo from "./ContactInfo";
import Address from "./Address";
import Appointment from "./Appointment";
import OtherInfo from "./OtherInfo";
import Message from "./Message";
import MessageScheduled from "./MessageScheduled";
import Note from "./Note";
import BizReviewFeedback from "./BizReviewFeedback";
import Chat from "./Chat";

export default class Customer extends Model {
  static entity = "customers";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      viewedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      messagesSnoozedUntil: this.attr().nullable(),
      messagesArchivedAt: this.attr().nullable(),
      chatsSnoozedUntil: this.attr().nullable(),
      chatsArchivedAt: this.attr().nullable(),
      emailsSnoozedUntil: this.attr().nullable(),
      emailsArchivedAt: this.attr().nullable(),
      isBusiness: this.boolean(false),
      firstName: this.attr(),
      middleName: this.attr(),
      lastName: this.attr(),
      companyName: this.attr(),
      calls: this.hasMany(Call, "customerId"),
      contactInfos: this.hasMany(ContactInfo, "customerId"),
      addresses: this.hasMany(Address, "customerId"),
      appointments: this.hasMany(Appointment, "customerId"),
      otherInfos: this.hasMany(OtherInfo, "customerId"),
      chats: this.hasMany(Chat, "customerId"),
      messages: this.hasMany(Message, "customerId"),
      messagesScheduled: this.hasMany(MessageScheduled, "customerId"),
      notes: this.hasMany(Note, "customerId"),
      bizReviewFeedbacks: this.hasMany(BizReviewFeedback, "customerId")
    };
  }

  get shortName() {
    if (this.isBusiness) {
      return this.companyName;
    } else {
      return [this.firstName, this.lastName.charAt(0)].join(" ");
    }
  }

  get longName() {
    if (this.isBusiness) {
      return this.companyName;
    } else {
      return [this.firstName, this.lastName].join(" ");
    }
  }

  get fullName() {
    if (this.isBusiness) {
      return this.companyName;
    } else {
      return [this.firstName, this.middleName, this.lastName].join(" ");
    }
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      viewedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
